module.exports = __webpack_public_path__ + "static/media/digitalScreen.80248bdf.svg";